
export const TAG__APP_PAGE_CHANGE = 'app:pageChange';
export const TAG__APP_NEWS_CATEGORY_CHANGE = 'app:newsCategorySelectedChange';
export const TAG__USER_POSITION_CHANGE = 'app:userPositionChange';
// export const TAG__APP_EVENTS_CATEGORY_CHANGE = 'app:eventsCategorySelectedChange';
export const TAG__APP_EVENTS_CATEGORIES_CHANGE = 'app:eventsCategoriesChange';
export const TAG__APP_MAP_TRAFFIC_ENABLED_CHANGE = 'app:mapTrafficEnabledChange';
// export const TAG__APP_MAP_ACTIVE_LAYER_CHANGE = 'app:mapActiveLayerChange';
export const TAG__TPL_LOADING_DATA_STATE_CHANGE = 'app:tplLoadingDataStateChange';
export const TAG__TPL_STOPS_CHANGE = 'app:tplStopsChange';

// constant status message
export const MSG_STATUS_FAILED = -1;
export const MSG_STATUS_SENDING = 0;
export const MSG_STATUS_SENT = 1;
export const MSG_STATUS_RECEIVED = 2;
export const MSG_STATUS_SEEN = 3;

// constans messages detail 
export const MIN_HEIGHT_TEXTAREA: number = 24;
export const MAX_HEIGHT_TEXTAREA: number = 180;

// pagine
export const PARENT_PAGE_USERS: string = "users";
export const PARENT_PAGE_DETAIL_CONVERSATION: string = "dettaglio-conversazione";

// css
export const BCK_COLOR_CONVERSATION_SELECTED: string = "#EEEEEE";
export const BCK_COLOR_CONVERSATION_UNSELECTED: string = "#FFFFFF";


// WEBPACK FOOTER //
// ./src/utils/constants.ts